import { EventTracking, EventType } from '@app/tracking';
var PinterestTag = /** @class */ (function () {
    function PinterestTag(tagId, scriptPath) {
        if (scriptPath === void 0) { scriptPath = 'https://s.pinimg.com/ct/core.js'; }
        window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        var n = window.pintrk;
        n.queue = [], n.version = "3.0";
        var scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = scriptPath;
        document.body.appendChild(scriptTag);
        pintrk('load', tagId);
        pintrk('page');
        if (window.laravelDebug) {
            console.log("\u2705 Pinterest Tag Tracking initialized for \"".concat(tagId, "\""));
        }
        this.registerListeners();
    }
    PinterestTag.prototype.registerListeners = function () {
        // Page view
        EventTracking.listen(EventType.PageView, function (_a) {
            var title = _a.title, path = _a.path;
            pintrk('track', 'pagevisit');
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, function (_a) {
            var form = _a.form;
            pintrk('track', 'lead', {
                lead_type: form
            });
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, function (_a) {
            var searchQuery = _a.searchQuery;
            pintrk('track', 'search', {
                search_query: searchQuery
            });
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, function (event) {
            pintrk('track', 'AddToCart', {
                value: event.price,
                currency: event.currency,
                order_quantity: event.quantity
            });
        });
        // Custom events
        EventTracking.listen(EventType.Track, function (_a) {
            var category = _a.category, action = _a.action, label = _a.label, _b = _a.value, value = _b === void 0 ? '' : _b;
            if (category == 'E-Mail' || category == 'Phone') {
                pintrk('track', 'lead', {
                    lead_type: category
                });
            }
            else {
                pintrk('track', 'custom', {
                    category: category,
                    action: action,
                    label: label,
                    value: value
                });
            }
        });
    };
    return PinterestTag;
}());
export default PinterestTag;
